// extracted by mini-css-extract-plugin
export default {"profileHeader":"UserProfileDropdown_profileHeader__phChJ","loginName":"UserProfileDropdown_loginName__QnoDH","borrowerMenu":"UserProfileDropdown_borrowerMenu__AsZEr"};